import { EMBEDDED_PAGE_TYPES } from './constants';

export const getEmbedType = (path) => {
  const result = /\/(\w+)-embed\//g.exec(path);
  if (!result) {
    throw new Error('Unrecognized embed path pattern. Please use /\'type\'-embed.');
  }

  const iframeType = result[1];

  if (!EMBEDDED_PAGE_TYPES.includes(iframeType)) {
    throw new Error(`Unrecognized embed type: ${iframeType}`);
  }
  return iframeType;
};
